<template>
  <div class="profile">
    <KeyIndicator class="section-margin" />
    <CompanyInfo class="company-info" />
    <MainBusiness class="section-margin" />
    <ManagerWrapper :total="3" v-slot="{ managers, holdings }">
      <ManagerList :data="managers" class="section-margin">
        <MoreTitle title="公司高管" @click="goPage" />
      </ManagerList>
      <ManagerHoldingTimeline v-if="market !== 'hs'" :data="holdings" class="section-margin">
        <MoreTitle title="高管持股变动" @click="goPage" />
      </ManagerHoldingTimeline>
    </ManagerWrapper>
    <Dividends />
  </div>
</template>

<script>
import KeyIndicator from '@/components/f10/indicator/KeyIndicator.vue'
import CompanyInfo from '@/components/f10/company/CompanyInfo.vue'
import MainBusiness from '@/components/f10/mainBusiness/MainBusiness.vue'
import ManagerWrapper from '@/components/f10/manager/ManagerWrapper.vue'
import ManagerList from '@/components/f10/manager/ManagerList.vue'
import ManagerHoldingTimeline from '@/components/f10/manager/ManagerHoldingTimeline.vue'
import Dividends from '@/components/f10/behavior/Dividends.vue'
export default {
  name: 'Profile',
  components: {
    KeyIndicator,
    CompanyInfo,
    MainBusiness,
    ManagerWrapper,
    ManagerList,
    ManagerHoldingTimeline,
    Dividends
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    }
  },
  methods: {
    goPage() {
      this.$router.push({
        path: '/f10/manager',
        query: {
          symbol: this.symbol
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.company-info {
  border-bottom: 1px solid var(--border-color-1);
}
</style>
